// PfEntity_Shareholders.jsx
import React from "react";

/**
 * PfEntity_Shareholders
 *
 * Props:
 * - shareholders: array of { name, role, shares, holdingPercent }
 * - setShareholders: function to update shareholders array
 * - totalShares: number (total company shares)
 *
 * This component is purely presentational + state-callbacks (no API calls).
 */
export default function PfEntity_Company({
  form,
  handleChange
}) 

{

  return (
    <div style={{ marginTop: 20 }}>
  <table className="w3-table-all">
  <tbody>
    {/* Section Title */}
    
    <tr>
      <td colSpan="2">
        <label className="">Company Name</label>
        <input className="w3-input w3-border"
          name="companyName"
          value={form.companyName || ""}
          onChange={handleChange}
        />
      </td>
      <td colSpan="">
        <label className="">Registrar</label>
        <input className="w3-input w3-border"
          name="registrar"
          value={form.registrar || ""}
          onChange={handleChange}
        />
      </td>
      <td colSpan="">
        <label className="">Date of Incorporation</label>
        <input className="w3-input w3-border"
          type="date"
          name="incorporationDate"
          value={form.incorporationDate || ""}
          onChange={handleChange}
        />
      </td>
    </tr>

    <tr>
      <td colSpan="4">
        <label className="">Regd. Address</label>
        <input className="w3-input w3-border"
          name="registeredAddress"
          value={form.registeredAddress || ""}
          onChange={handleChange}
        />
      </td>
    </tr>

  </tbody>
</table>

    </div>
  );
}
